<template>
  <section class="section">
    <div class="container login">
      <div class="columns">
        <div class="column is-8 is-offset-2">
          <div>
            <h1 class="title is-3 has-text-centered">
              {{ $t('login.title') }}
            </h1>
          </div>
          <div class="box">
            <div class="columns">
              <div class="login__logo column is-5">
                <div class="level-item has-text-centered">
                  <figure class="image is-128x128">
                    <img src="/img/login_logo.png" />
                  </figure>
                </div>
              </div>
              <form class="login__form column is-7" @submit.prevent="auth">
                <b-field>
                  <b-input placeholder="login" name="login" v-model="login" v-validate="'required'"></b-input>
                </b-field>
                <b-field>
                  <b-input
                    type="password"
                    name="password"
                    placeholder="password"
                    v-model="password"
                    v-validate="'required'"
                    icon-pack="fas"
                    password-reveal
                  ></b-input>
                </b-field>
                <b-field>
                  <button class="button is-link">
                    {{ $t('button.login') }}
                  </button>
                </b-field>
              </form>
            </div>
          </div>
          <div class="footer columns">
            <div class="column is-3">
              <p>{{ about.copyright }}</p>
            </div>
            <div class="column is-6">
              <p>{{ about.software_name }} {{ about.software_version }}</p>
            </div>
            <div class="column is-3">
              <b-field>
                <b-select expanded placeholder="Language" v-model="$i18n.locale">
                  <option v-for="(language, i) in languages" :key="`language${i}`" :value="language.value">{{
                    language.title
                  }}</option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      login: null,
      password: null,
      about: {}
    }
  },
  computed: {
    languages() {
      return [
        {
          value: 'en',
          title: 'English'
        }
        //{
        //  value: 'ru',
        //  title: 'Russian'
        //}
      ]
    }
  },
  watch: {
    '$i18n.locale'(language) {
      this.setLanguage(language)
    }
  },
  created() {
    fetch((process.env.VUE_APP_API_ENDPOINT || window.location.origin) + '/api/about', {
      credentials: 'omit'
    })
      .then(res => res.json())
      .then(data => (this.about = data))
  },
  methods: {
    ...mapActions('general', ['setLanguage', 'setUser', 'setUserAlarms']),
    fetchCurrentUser() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/settings/user`
      return fetch(url, {
        method: 'GET',
        credentials: 'include'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(data => {
          this.setUser(data)
          this.setUserAlarms(data.alarms)
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    auth() {
      this.$validator
        .validateAll()
        .then(is_valid => {
          if (is_valid) {
            fetch(`${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/login`, {
              credentials: 'include',

              body: JSON.stringify({
                login: this.login,
                password: this.password,
                lang: this.$i18n.locale
              }),
              method: 'POST'
            })
              .then(response => {
                if (response.ok) {
                  this.setUser({
                    login: this.login
                  })

                  this.$router.push('/')
                } else {
                  throw this.$t('settings.user.wrongCredentials')
                }

                return this.fetchCurrentUser()
              })
              .catch(err => {
                this.$notify({
                  message: err,
                  type: 'danger'
                })
              })
          }
        })
        .catch(() =>
          this.$notify({
            message: `${this.$t('error.validation')}`,
            type: 'danger'
          })
        )
    }
  }
}
</script>

<style scoped lang="scss">
.login {
  max-width: 48rem;
  margin: 0 auto;

  .box {
    margin-top: 2rem;
  }

  .footer {
    background: none;
    padding: 0;

    .column {
      display: flex;
      align-items: center;
    }
  }
}
</style>
